<div class="tasks-history-container">
  <div class="history-header">
    <div class="title-section">
      <div class="title-container">
        <div class="inner-tab-title">Task History</div>
      </div>
    </div>
    <div class="filter-buttons">
      <app-button
        buttonVariant="filter"
        buttonType="button"
        [active]="filtersApplied"
        (buttonClick)="toggleFilters()"
        >
        <img [src]="'shared-assets/icons/filter.png'" alt="Filter Icon" class="filter-icon" />
        <span>Filters</span>
        @if (filtersApplied) {
          <span
            class="clear-icon"
            (click)="clearFilters(); $event.stopPropagation()"
            title="Clear filters"
            >
            <img src="shared-assets/icons/close.png" alt="Clear Icon" class="clear-icon" />
          </span>
        }
      </app-button>
      <app-pill-search
        [searchText]="searchValue"
        placeholder="Search"
        (searchChange)="updateSearch($event)"
        [isDisabled]="isDisabled"
      ></app-pill-search>
    </div>
  </div>

  <div class="table-container">
    <!-- Loading state -->
    @if (initialLoading) {
      <div class="loading-container">
        <app-loading-spinner size="large" label="Loading task history..."></app-loading-spinner>
      </div>
    }
    @if (!initialLoading) {
      <table class="history-table">
        <thead>
          <tr>
            <th class="col-type">Type</th>
            <th class="col-resolved-by">Resolved by</th>
            <th class="col-resolution-date">Resolution Date</th>
            <th class="col-resolution">Resolution</th>
          </tr>
        </thead>
        <tbody>
          <!-- Error state -->
          @if (error && !initialLoading) {
            <tr>
              <td colspan="4" class="error-cell">
                <div class="error-container">
                  <mat-icon>error</mat-icon>
                  <span>{{ error }}</span>
                  <button mat-button (click)="resetAndLoadHistory()">Retry</button>
                </div>
              </td>
            </tr>
          }
          <!-- Empty state -->
          @if (!initialLoading && !error && tasks.length === 0) {
            <tr class="empty-row">
              <td colspan="8">
                <app-empty-state
                  [filtersApplied]="filtersApplied"
                  [searchText]="searchValue"
                ></app-empty-state>
              </td>
            </tr>
          }
          <!-- Task history data -->
          @for (task of tasks; track task.id; let i = $index) {
            <tr
              class="table-row"
              [ngClass]="{ 'row-highlighted': selected === task }"
              (click)="onTaskClick(task)"
              >
              <td class="cell-type">{{ task.title }}</td>
              <td class="cell-resolved-by">{{ task.resolvedByDisplayName }}</td>
              <td class="cell-resolution-date">
                {{ task.resolvedAt | date : 'dd MMM, hh:mm a' }}
              </td>
              <td class="cell-resolution">
                <span class="resolution-badge" [ngClass]="getResolutionClass(task.resolution!)">
                  {{ getResolutionText(task.resolution!) }}
                </span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
    <app-show-more
      [isShowMore]="hasMore && !initialLoading"
      [isLoading]="isLoading"
      (loadMore)="loadMore()"
    ></app-show-more>
  </div>
</div>
